import { Outlet } from 'react-router';

/** Maintenance page shell. Width follows the platform Helpdesk container. */
export function MaintenanceLayout() {
  return (
    <div className="flex w-full min-w-0 flex-col gap-4 overflow-x-clip">
      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
